import React, { Component } from 'react'
import Container from '../../components/layout/container.component'
import Title from '../../components/typography/title.component'
import { StyledRegulation } from './rebooking.styles'

class RebookingPage extends Component {
	render() {
		return (
			<Container style={{ paddingBottom: '5rem' }}>
				<Title>
					<span className="bold">
						Remarcação e Transferência de Passagens
					</span>
				</Title>
				<StyledRegulation>
					<br></br>
					<div>
						<h3>
							<strong>Caso deseje remarcar ou transferir sua passagem, siga as
							orientações abaixo:</strong>
						</h3>
						<p>
							Com base nas legislações vigentes, apresentamos um resumo
							das etapas para a solicitação de remarcações ou transferências 
							disponíveis exclusivamente para passagens da Planalto Transportes 
							na operação de transporte rodoviário interestadual.
						</p>
						<ol>
							<li>
								<strong>Remarcação de Passagens Interestadual:</strong>
								<ul>
									<li>
										Para remarcar sua passagem interestadual, siga os passos a seguir:
										<ul>
											<li>
												Acesse o site Muviflex com seu cadastro e logado.
											</li>
											<li>
												Vá até o menu {' '}
												<a href="https://www.muviflex.com.br/cliente/minhas-compras">
												Minhas compras
												</a>
											</li>
											<li>
												Localize o pedido.
											</li>
											<li>
												Selecione a opção de Remarcação.
											</li>
											<li>
												Em seguida, você será direcionado à busca por novos horários e, 
												por fim, poderá inserir os dados necessários para confirmar a nova viagem.
											</li>
										</ul>
									</li>
									<li>
										Caso você não tenha cadastro será necessário a realização do mesmo. 
										Para tanto, basta você acessar o site Muviflex e clique em "Entrar". 
										Na tela de login, clique em "Esqueci a senha" e informe o e-mail 
										utilizado na compra. Redefina a senha via e-mail recebido e efetue login 
										no site. Após isso, efetue os passos do item anterior.
									</li>
								</ul>
							</li>
							<li>
								<strong>Multa e Pagamento de diferença de valor da tarifa de passagens Interestaduais:</strong>
								<ul>
									<li>
										A remarcação da passagem interestadual efetuada com até 3 horas de antecedência 
										ao horário previsto para embarque será isenta de multa.
									</li>
									<li>
										Conforme estabelecido na Resolução nº 5.974/2022, caso a solicitação de remarcação
										do Bilhete de Passagem, prevista no inciso VIII, seja realizada a partir 
										de 3 (três) horas antes do início da viagem, a transportadora poderá, 
										a seu critério, cobrar uma taxa de remarcação de até 20% (vinte por cento) 
										do valor da tarifa. Este procedimento poderá ser realizado para qualquer data 
										disponível dentro do prazo de 1 (um) ano a partir da data original da compra.
									</li>
									<li>
										No caso de remarcação do bilhete, o passageiro pode optar por serviço em 
										veículo de categoria diversa do originalmente contratado, arcando com as 
										diferenças dos valores de tarifa, no caso de serviço em veículo de categoria 
										superior, ou tendo direito à restituição das diferenças de preço, 
										no caso de serviço em veículo de categoria inferior.
									</li>
									<li>
										NUNCA EFETUE NOVA COMPRA NO LUGAR DA PASSAGEM QUE DESEJA REMARCAR. 
										Não conseguimos cancelar passagens após o início do embarque, 
										apenas realizar a remarcação mediante pagamento de multa, a partir de 3 
										(três) horas antes do horário do início da viagem até a data de validade do bilhete. 
									</li>
								</ul>
							</li>
							<li>
								<strong>Remarcação de Passagem Intermunicipal:</strong>
								<ul>
									<li>
										As solicitações de remarcação para viagens intermunicipais podem ser feitas 
										até três horas antes do horário de partida.
									</li>
									<li>
										Após o prazo estabelecido, não será possível realizar alteração 
										ou cancelamento da passagem, conforme Lei Estadual n° 14834/2016.
									</li>
									<li>
										Em caso de cancelamento realizado dentro do prazo, o passageiro 
										terá o direito ao reembolso do valor pago, com retenção da taxa de serviço, 
										conforme item 6.1.4 do {' '} 
										<a href="https://www.muviflex.com.br/regulamento">
										Regulamento do Muviflex
										</a>
									</li>
									<li>
										A remarcação da passagem intermunicipal, quando efetuada, 
										sempre com pelo menos  03 horas antes do início do embarque, 
										pode ser realizada diretamente no site Muviflex. 
										Para isso, siga os passos a seguir:
										<ul>
											<li>
												Acesse o site Muviflex com seu cadastro e logado.
											</li>
											<li>
												Vá até o menu {' '}
												<a href="https://www.muviflex.com.br/cliente/minhas-compras">
												Minhas compras
												</a>
											</li>
											<li>
												Localize o pedido.
											</li>
											<li>
												Selecione a opção de Remarcação.
											</li>
											<li>
												Em seguida, você será direcionado à busca por novos horários e, 
												por fim, poderá inserir os dados necessários para confirmar a nova viagem.
											</li>
										</ul>
									</li>
									<li>
										Caso você não tenha cadastro será necessário a 
										realização do mesmo. Para tanto, basta você acessar o 
										site Muviflex e clique em "Entrar". Na tela de login, 
										clique em "Esqueci a senha" e informe o e-mail utilizado na compra. 
										Redefina a senha via e-mail recebido e efetue login no site. 
										Após isso, efetue os passos do item anterior.
									</li>
									<li>
										No caso de remarcação do bilhete, o passageiro 
										pode optar por serviço em veículo de categoria diversa 
										do originalmente contratado, arcando com as diferenças dos valores 
										de tarifa, no caso de serviço em veículo de categoria superior, 
										ou tendo direito à restituição das diferenças de preço, 
										no caso de serviço em veículo de categoria inferior.
									</li>
								</ul>
							</li>
							<li>
								<strong>Transferência de Passagens Interestaduais:</strong>
								<ul>
									<li>
										A transferência de passagens é um serviço exclusivo da 
										operação interestadual, não sendo possível no site 
										Muviflex para as passagens intermunicipais.
									</li>
									<li>
										A transferência de passagens é uma funcionalidade que 
										permite alterar o nome e documento do passageiro, ou seja, 
										transferir a passagem para um outro viajante.
									</li>
									<li>
										A transferência, que será realizada no site Muviflex, 
										com usuário logado, é realizada pelo titular do 
										cadastro no site Muviflex 
									</li>
									<li>
										Para transferir sua passagem, siga os passos a seguir:
										<ul>
											<li>
												Acesse o site Muviflex com seu cadastro e logado.
											</li>
											<li>
												Vá até o menu {' '}
												<a href="https://www.muviflex.com.br/cliente/minhas-compras">
												Minhas compras
												</a>
											</li>
											<li>
												Localize o pedido.
											</li>
											<li>
												Selecione a opção de transferência.
											</li>
											<li>
												Em seguida, poderá inserir os dados de nome e documento do novo 
												passageiro necessários para a emissão da nova passagem no nome do passageiro.
											</li>
											<li>
												OBS: A RESPONSABILIDADE DA TRANSFERÊNCIA É INTEIRAMENTE DO PROPRIETÁRIO DO CADASTRO.
											</li>
										</ul>
									</li>
									<li>
										Após a transferência, a passagem original com os dados do primeiro passageiro 
										deixa de ser válida para uso, imediatamente. 
									</li>
								</ul>
							</li>
							<li>
								<strong>Informações Adicionais:</strong>
								<ul>
									<li>
										A confirmação de cadastro, alterações de senha, cancelamentos, 
										transferências e remarcações serão enviadas exclusivamente para o 
										e-mail registrado no cadastro do cliente. É de responsabilidade 
										do cliente garantir que o e-mail informado esteja correto e 
										atualizado, assegurando o recebimento das comunicações.
									</li>
								<strong>Solicitação de Alteração, Correção e Eliminação de Dados Cadastrais:</strong>
									<li>
										Para garantir a segurança e a proteção de nossos clientes, 
										solicitamos que, ao fazer um pedido de alteração, correção 
										ou eliminação de dados cadastrais, você envie uma cópia legível 
										do seu documento de identidade (frente e verso), juntamente 
										com uma selfie segurando o documento ao lado do rosto. Esta 
										medida é necessária para confirmar que a solicitação está sendo 
										feita pelo próprio titular dos dados. Por favor, certifique-se de 
										que a foto do documento esteja legível para facilitar o processamento da solicitação.
									</li>
									<li>
										O requerimento expresso deve ser enviado para o e-mail:
										encarregadodedados@jmt.com.br ou faleconosco@muviflex.com.br
									</li>
									<li>
										Essas precauções são adotadas para proteger os dados pessoais 
										de nossos clientes e garantir que alterações, correções ou 
										exclusões solicitadas pelos titulares de dados sejam realizadas de 
										forma segura e legítima. Reservamo-nos o direito de solicitar informações 
										adicionais que julgarmos necessárias para cumprir essa finalidade com segurança e precisão.
									</li>
									<li>
										Caso haja qualquer dúvida sobre como tratamos seus dados pessoais acesse: {' '}
										<a href="https://www.muviflex.com.br/politica-de-privacidade">
										Política de Privacidade
										</a>
									</li>
								</ul>
							</li>
						</ol>
						<p>Agradecemos por escolher o Muviflex para suas viagens!</p>
					</div>
				</StyledRegulation>
			</Container>
		)
	}
}

export { RebookingPage as ModuleRootComponent }
